/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_Lower_HalfInputs */

const en_ocr_crop_lower_half = /** @type {(inputs: Ocr_Crop_Lower_HalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lower Half`)
};

const fr_ocr_crop_lower_half = /** @type {(inputs: Ocr_Crop_Lower_HalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partie inférieure`)
};

const de_ocr_crop_lower_half = /** @type {(inputs: Ocr_Crop_Lower_HalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untere Hälfte`)
};

const it_ocr_crop_lower_half = /** @type {(inputs: Ocr_Crop_Lower_HalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`metà inferiore`)
};

const ru_ocr_crop_lower_half = /** @type {(inputs: Ocr_Crop_Lower_HalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нижняя половина`)
};

const es_ocr_crop_lower_half = /** @type {(inputs: Ocr_Crop_Lower_HalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitad inferior`)
};

const zh_cn2_ocr_crop_lower_half = /** @type {(inputs: Ocr_Crop_Lower_HalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下半部分`)
};

const ja_ocr_crop_lower_half = /** @type {(inputs: Ocr_Crop_Lower_HalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下半身`)
};

const hi_ocr_crop_lower_half = /** @type {(inputs: Ocr_Crop_Lower_HalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निचला आधा`)
};

const pt_pt2_ocr_crop_lower_half = /** @type {(inputs: Ocr_Crop_Lower_HalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metade inferior`)
};

/**
* | output |
* | --- |
* | "Lower Half" |
*
* @param {Ocr_Crop_Lower_HalfInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_lower_half = /** @type {((inputs?: Ocr_Crop_Lower_HalfInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_Lower_HalfInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_crop_lower_half(inputs)
	if (locale === "de") return de_ocr_crop_lower_half(inputs)
	if (locale === "it") return it_ocr_crop_lower_half(inputs)
	if (locale === "ru") return ru_ocr_crop_lower_half(inputs)
	if (locale === "es") return es_ocr_crop_lower_half(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_crop_lower_half(inputs)
	if (locale === "ja") return ja_ocr_crop_lower_half(inputs)
	if (locale === "hi") return hi_ocr_crop_lower_half(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_crop_lower_half(inputs)
	return en_ocr_crop_lower_half(inputs)
});